import {
  CAlert, CButton, CCol, CContainer, CForm, CFormGroup,
  CInput, CLabel, CModal, CModalBody, CModalFooter, CModalHeader,
  CModalTitle, CRow, CSelect, CSpinner, CTextarea
} from '@coreui/react';
import React, { useEffect, useState } from 'react';
import Notify from '../../utils/Notify';

export default function AddBookModal(props) {
  const books = props.books
  const bookRef = props.bookRef
  let startNumber = 1
  const booksNumber = Array.from(new Array(66), () => startNumber++)
  const bookModel = {
    number: '',
    name: '',
    author: '',
    heading: '',
    year: '',
    description: '',
    chapters: [],
  }
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [book, setBook] = useState(bookModel)
  const [editMode, setEditMode] = useState(props.book)

  function handleBookChange(evt) {
    setError('')
    let value = evt.target.value;
    let name = evt.target.name;
    let existingBook = null;
    if (name == 'number' && value) {
      existingBook = books.find(book => value == book.number)
      // Reset fields
      if (!existingBook) {
        setBook({ ...bookModel, number: value })
        return
      }
    }

    if (existingBook) {
      setBook(existingBook)
      setEditMode(true)
    } else {
      setEditMode(false)
      setBook({ ...book, [name]: value })
    }
  }

  function validateBook() {
    if (!book.number) {
      setError('Select Book Number')
      return false;
    } else if (!book.name) {
      setError('Enter Book Name')
      return false
    }

    return true
  }

  function handleSubmit() {
    setLoading(true)

    if (!validateBook()) {
      setLoading(false)
      return
    }

    try {
      book.number = parseInt(book.number)
      book.heading = book.heading.toString().replace('_', 'ṭ')
      book.description = book.description.toString().replace('_', 'ṭ')
      bookRef
        .doc(book.number.toString())
        .set(book)
        .then(() => {
          props.onClose()
          let message = 'Book added successfully.'
          if (editMode) {
            message = 'Book updated successfully.'
          }
          Notify.success(message)
        })
        .catch(error => {
          throw error
        })
    } catch (error) {
      console.log(error)
      setError('Something went wrong. Please try again.')
      setLoading(false)
    }
  }

  useEffect(() => {
    if (props.book) {
      setBook(props.book)
    }
  }, [])

  return (
    <>
      <CModal
        size={'lg'}
        show={props.show}
        centered={true}
        onClose={() => props.onClose()}
      >
        <CModalHeader closeButton>
          <CModalTitle>{!props.book && 'Add/'}Edit Book</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CContainer fluid>
            <CRow>
              {
                error && <CAlert color="danger" className="w-100">{error}</CAlert>
              }
              <CCol sm="12">
                <CForm onSubmit={e => {
                  e.preventDefault()
                  handleSubmit()
                }}>
                  <CFormGroup>
                    <CLabel htmlFor="book-number">Select Book Number</CLabel>
                    <CSelect custom name="number" id="book-number"
                      disabled={props.book != null}
                      onChange={e => handleBookChange(e)}>
                      <option value="">Select Book Number</option>
                      {
                        booksNumber.map(bookNumber => {
                          return (
                            <option value={bookNumber} selected={bookNumber == book.number}>
                              Book {bookNumber}
                            </option>
                          )
                        })
                      }
                    </CSelect>
                  </CFormGroup>
                  <CFormGroup>
                    <CLabel>Name</CLabel>
                    <CInput
                      value={book.name}
                      type="text"
                      name="name"
                      placeholder="Enter Book Name"
                      onChange={(e) => handleBookChange(e)}
                    />
                  </CFormGroup>
                  <CFormGroup>
                    <CLabel>Author</CLabel>
                    <CInput
                      value={book.author}
                      type="text"
                      name="author"
                      placeholder="Enter Author"
                      onChange={(e) => handleBookChange(e)}
                    />
                  </CFormGroup>
                  <CFormGroup>
                    <CLabel>Year</CLabel>
                    <CInput
                      value={book.year}
                      type="text"
                      name="year"
                      placeholder="Enter Year of Writing"
                      onChange={(e) => handleBookChange(e)}
                    />
                  </CFormGroup>
                  <CFormGroup>
                    <CLabel>Heading (Thupui)</CLabel>
                    <CTextarea
                      value={book.heading}
                      type="text"
                      name="heading"
                      placeholder="Enter Heading"
                      rows={'1'}
                      onChange={(e) => handleBookChange(e)}
                    />
                  </CFormGroup>

                  <CFormGroup>
                    <CLabel>Description</CLabel>
                    <CTextarea
                      onChange={(e) => handleBookChange(e)}
                      name="description"
                      value={book.description}
                      rows="10"
                    />
                  </CFormGroup>
                </CForm>
              </CCol>
            </CRow>
          </CContainer>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="danger" className="btn-sm pl-4 pr-4"
            disabled={loading}
            onClick={() => props.onClose()}>Cancel</CButton>
          <CButton color="dark" className="btn-sm pl-4 pr-4"
            disabled={loading}
            onClick={e => {
              e.preventDefault()
              handleSubmit()
            }}>
            {
              loading ?
                (
                  <>
                    <CSpinner component="span" size="sm" aria-hidden="true" />
                    Saving...
                  </>
                ) : 'Save'
            }
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}
